export const HONOR_CODE_LINES = [
	"I'll do the work or own the miss —",
	'honest reps, nothing less than this.'
];

export const HONOR_CODE_SUBLINE = 'Fantasy Fitness Honor Code';

export function honorCodeFirstName(fullName) {
	if (!fullName?.trim()) return '';
	return fullName.trim().split(/\s+/)[0];
}
